<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-row>
        <v-col cols="2">
          <v-icon @click="goBack">
            mdi-chevron-left
          </v-icon>
        </v-col>
        <v-col class="d-flex justify-space-around">
          <v-toolbar-title class="pageTitle">
            Pfandrückgabe
          </v-toolbar-title>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider class="headerDivider"/>

    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
    <v-stepper v-model="depositStepper" alt-labels class="createUserStepper" >
      <v-stepper-header>
        <v-stepper-step
            :complete="depositStepper > 1"
            step="1"
        >
          Markt auswählen
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
            :complete="depositStepper > 2"
            step="2"
        >
          Pfand eingeben
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">
          Überprüfen
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items class="createUserStepper">
        <v-stepper-content step="1">
          <v-card class="stepperSearchWrapper">
            <v-container class="stepperSearchContainer">
              <span>Kundenauswahl</span>

              <v-text-field class="searchCbx"
                            append-icon=""
                            outlined
                            dense
                            v-model="marketSearchCbx"
                            hide-details
                            placeholder="Kundenname..."

              >

                <template v-slot:prepend>
                  <magnifyGlass_small/>
                </template>
                <template v-slot:append v-if="loadingResults">
                  <v-progress-circular indeterminate class="searchProgressCircular"/>
                </template>
              </v-text-field>
            </v-container>
          </v-card>
          <v-row v-if="!loadingResults" :key="marketsFiltered">
            <v-col cols="12"
                   v-for="market in markets"
                   :key="market.customerNo"
            >
              <v-card class="marketWrapper">
                <v-container>
                  <span class="marketName">{{ market.marketName }}</span>
                  <br>
                  <span class="customerId">Kundennummer: {{ market.customerNo }}</span>
                  <br>

                  <span class="address">
                        {{ market.address }}
                        <br>
                        {{ market.city }}
                      </span>
                  <v-btn class="marketSelectBtn"
                         @click="selectMarket(market.customerNo, market.marketName);setMarket();depositStepper = 2"
                  >
                    Auswählen
                  </v-btn>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2" class="createUserStepper">
          <v-card class="depositListCard">
            <v-container class="depositListContainer" v-if="!isLoading">
              <table>
                <thead>
                  <td>
                    <b>Pfandtyp</b>
                  </td>

                  <td>
                    <b>Anzahl</b>
                  </td>
                </thead>
                <tbody>
                <tr v-for="depositItem in nonSachetValues"
                    :key="depositItem.itemNo">
                  <td>
                    <span>
                      {{ depositItem.description }}
                      <br>
                      {{ depositItem.itemNo }}
                    </span>
                  </td>
                  <td>
                    <v-text-field class="searchCbx depositListInput"
                                  rounded
                                  dense
                                  outlined
                                  type="number"
                                  role="gridcell"
                                  @blur="updateDeposits(depositItem.itemNo, $event.target.value)"
                                  :v-model="depositItem.itemNo"
                                  :value="depositAmount === null ? '' : depositAmount[depositItem.itemNo]"
                    >

                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                <th>
                  <tr>
                    <td>
                      DPG Pfandsäcke
                    </td>
                  </tr>
                </th>
                <tr v-for="(depositItem,index) in sachetValues"
                    :key="depositItem.itemNo+'-'+index">
                  <!--
                  <td>
                      <span>
                        {{ depositItem.description }}
                        <br>
                        {{ depositItem.itemNo }}
                      </span>
                  </td>
                  -->
                  <td>
                    <v-text-field class="searchCbx depositListInput"
                                  rounded
                                  dense
                                  outlined
                                  type="input"
                                  maxLength="20"
                                  @blur="updateSachet(depositItem.itemNo, $event.target.value, index)"
                                  :v-model="depositItem.itemNo[index]"
                                  :value="depositAmount === null ? '' : (depositAmount[depositItem.itemNo] !== undefined ? depositAmount[depositItem.itemNo][index] : '')"
                    >

                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </table>

            </v-container>
            <v-btn class="sachet-btn" @click="addSachet">
              <span>Weiteren Pfandsack hinzufügen</span>
            </v-btn>
            <v-btn
                @click="depositStepper = 3"
                class="continueBtn"
            >
              <span>Weiter</span>
            </v-btn>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="depositListWrapper">
          <v-card class="depositListCard">
            <v-container class="depositListContainer">
              <table>
                <thead>
                <td>
                  <b>Pfandtyp</b>
                </td>

                <td>
                  <b>Anzahl</b>
                </td>
                </thead>
                <tbody>
                <tr v-for="depositItem in nonSachetValues"
                    :key="depositItem.itemNo">
                  <td>
                      <span>
                        {{ depositItem.description }}
                        <br>
                        {{ depositItem.itemNo }}
                      </span>
                  </td>
                  <td>
                    <v-text-field class="searchCbx depositListInput"
                                  rounded
                                  dense
                                  outlined
                                  type="number"
                                  disabled
                                  :v-model="depositItem.itemNo"
                                  :value="depositAmount === null ? '' : depositAmount[depositItem.itemNo]"
                    >

                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                <th>
                  <tr>
                    <td>
                      DPG Pfandsäcke
                    </td>
                  </tr>
                </th>
                <tr v-for="(depositItem,index) in sachetValues"
                    :key="depositItem.itemNo+'-'+index">
                  <!--
                  <td>
                      <span>
                        {{ depositItem.description }}
                        <br>
                        {{ depositItem.itemNo }}
                      </span>
                  </td>
                  -->
                  <td>
                    <v-text-field class="searchCbx depositListInput"
                                  rounded
                                  dense
                                  outlined
                                  disabled
                                  type="input"
                                  maxLength="20"
                                  :v-model="depositItem.itemNo[index]"
                                  :value="depositAmount === null ? '' : (depositAmount[depositItem.itemNo] !== undefined ? depositAmount[depositItem.itemNo][index] : '')"
                    >

                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </table>
            </v-container>

          <v-container class="signatureContainer">
            <div class="signaturePlaceholder"
                 v-if="this.showSignature === null"
                 @click="this.setSignaturePadState"
            >
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 498.1818073840183 955.4545247456264" width="498.1818073840183" height="955.4545247456264"/>
            </div>
            <div class="signatureWrapper"

                 v-if="this.showSignature !== null"
            >
              <div class="signatureDisplay">
                <v-btn class="deleteSignature-btn" @click="deleteSignature">
                  <close-btn/>
                </v-btn>
                <div class="signatureSVG" v-html="showSignature">

                </div>
              </div>
            </div>
            <div class="signatureSubline">
              Unterschrift
            </div>
          </v-container>
            <v-btn
                class="continueBtn"
                color="primary"
                @click="endDepositCollection"
                v-if="onlineState"
            >
              Pfandrückgabe abschließen
            </v-btn>
            <v-btn
                class="continueBtn"
                color="primary"
                @click="saveToStorage"
                v-if="!onlineState"
            >
              Zwischenspeichern (Offline-Modus)
            </v-btn>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
      <v-snackbar :value="triggerSnackbar" class="depositSnackBar">
        <span>Die Pfandrückgabe konnte nicht verarbeitet werden. Sie wurde in den Zwischenspeicher verschoben.</span>
      </v-snackbar>
      <div class="bottomFiller"/>
    </div>
    <v-dialog v-model="this.thresholdValueExceeded" persistent content-class="depositStartOption">
      <v-card class="marketWrapper">
        <v-container>
          <v-card-text class="textSize__16">
            Der Wert der Leergutartikel überschreitet den Grenzwert von 500€.
            <br>
            <br>
            Sind die Positionen korrekt angegeben?
          </v-card-text>
          <v-btn  @click="postThresholdCheck"
                  class="depositResetBtn">
            Ja
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn  @click="thresholdValueExceeded = false"
                  class="depositContBtn">
            Nein
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import {mapActions, mapMutations, mapState} from 'vuex'
import router from '@/router'
import magnifyGlass_small from "@/assets/magnifyGlass_small";
import CloseBtn from "@/assets/closeBtn";

export default {
  name: "bottleDepositList",
  components : {CloseBtn, magnifyGlass_small},
  props: ['externalSetMarket', 'comesFromTours'],
  data() {
    return {
      thresholdValueExceeded: false,
      depositStepper: 1,
      depositValues: null,
      depositAmount: null,

      marketSearchCbx: '',
      marketSearch: null,
      marketResults : [],
      loadingResults: false,
      marketsFiltered: false,
      activeMarket: null,
      currentDeposit: null,

      onlineState: true,

      isLoading: true,
      triggerSnackbar: false,
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
      sendDepositCollection: 'sendDepositCollection'
    }),

    ...mapMutations({
      setSignaturePadState: 'setSignaturePadState',
      setDepositCollectorOnList: 'setDepositCollectorOnList',
      setSignatureSVG: 'setSignatureSVG'
    }),

    ...mapState({
      signatureSVG: 'signatureSVG'
    }),

    goBack() {
      if(this.externalSetMarket && this.depositStepper === 2) {
        router.go(-1)
        return
      }
      if(this.depositStepper > 1) {
        this.depositStepper -= 1
      }

      else {
        router.go(-1)
      }
    },

    addSachet() {
      let sachets = this.depositValues.filter(el => {
        if(el.itemNo === '79110') {
          return true
        } else {
          return false
        }
      })
      this.depositAmount[sachets[0].itemNo].push(null)
    },

    deleteSignature() {
      this.setSignatureSVG(null)

      let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
      delete currentDeposit['signature']
      delete currentDeposit['signature_jpeg']

      localStorage.setItem('currentDeposit', JSON.stringify(currentDeposit))
    },

    setMarket() {
      if(!JSON.parse(localStorage.getItem('currentDeposit'))) {
        localStorage.setItem('currentDeposit', '{}')
      }
      let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
      currentDeposit['market'] = this.activeMarket
      localStorage.setItem('currentDeposit', JSON.stringify(currentDeposit))
    },

    updateSachet(depositId, value, index) {
      let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
      if(parseInt(value) < 1 || value === '' ) {
        delete currentDeposit[depositId]
      }
      else {
        if(!('deposit' in currentDeposit)) {
          currentDeposit['deposit'] = {}
        }
        if(currentDeposit['deposit'][depositId] === undefined) {
          currentDeposit['deposit'][depositId] = [value]
        } else {
          currentDeposit['deposit'][depositId][index] = value
        }

      }
      this.setDepositCollectorOnList(currentDeposit)
      this.depositAmount = currentDeposit['deposit']
      localStorage.setItem('currentDeposit', JSON.stringify(currentDeposit))
    },
    updateDeposits(depositId, value) {
      let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
      if(parseInt(value) < 1 || value === '' ) {
        delete currentDeposit[depositId]
      }
      else {
        if(!('deposit' in currentDeposit)) {
          currentDeposit['deposit'] = {}
        }
        currentDeposit['deposit'][depositId] = value
      }
      this.setDepositCollectorOnList(currentDeposit)
      this.depositAmount = currentDeposit['deposit']
      localStorage.setItem('currentDeposit', JSON.stringify(currentDeposit))
    },

    initializeDeposit() {
      if(!localStorage.getItem('currentDeposit')) {
        localStorage.setItem('currentDeposit', '{}')
      }
      else {
        let currentDepositLocal = JSON.parse(localStorage.getItem('currentDeposit'))
        if(Object.keys(currentDepositLocal).length > 0) {
          if(!('deposit' in currentDepositLocal)) {
            this.setDepositCollectorOnList(currentDepositLocal)
            this.depositAmount = []
          }
          else {
            this.setDepositCollectorOnList(currentDepositLocal)
            this.depositAmount = currentDepositLocal['deposit']
          }
        }
        else {
          localStorage.setItem('currentDeposit', '{}')
        }
      }
    },

    searchMarkets(val) {
      if(val.length === 3 && this.marketResults.length === 0) {
        this.loadingResults = true

        if(this.onlineState) {
          if(localStorage.getItem('customers') === null) {
            axios.post('/api/searchCustomer')
                .then((result) => {
                  localStorage.setItem('customers', JSON.stringify(result.data))
                  const searchVal = this.marketSearchCbx.toLowerCase().trim()
                  this.marketResults = result.data.filter(val =>
                      (val.city ? val.city : '').toLowerCase().indexOf(searchVal) > -1 ||
                      (val.address ? val.address : '').toLowerCase().indexOf(searchVal) > -1 ||
                      (val.postal ? val.postal : '').toLowerCase().indexOf(searchVal) > -1 ||
                      (val.customerNo ? val.customerNo : '').toString().indexOf(searchVal) > -1 ||
                      (val.marketName ? val.marketName : '').toLowerCase().indexOf(searchVal) > -1)
                })
                .finally(() =>{
                  this.loadingResults = false
                  if(this.marketResults.length > 0) {
                    this.searchActive = true
                  }
                })
          }
          else {
            const params = {
              searchTerm: val
            }
            axios.post('/api/searchCustomer', params)
                .then((result) => {
                  this.marketResults = result.data
                })
                .finally(() =>{
                  this.loadingResults = false
                  if(this.marketResults.length > 0) {
                    this.searchActive = true
                  }
                })
          }
        }
        else {
          let customers = JSON.parse(localStorage.getItem('customers'))
          const searchVal = this.marketSearchCbx.toLowerCase().trim()
          this.marketResults = customers.filter(val =>
              (val.city ? val.city : '').toLowerCase().indexOf(searchVal) > -1 ||
              (val.address ? val.address : '').toLowerCase().indexOf(searchVal) > -1 ||
              (val.postal ? val.postal : '').toLowerCase().indexOf(searchVal) > -1 ||
              (val.customerNo ? val.customerNo : '').toString().indexOf(searchVal) > -1 ||
              (val.marketName ? val.marketName : '').toLowerCase().indexOf(searchVal) > -1)
          this.loadingResults = false
        }
      }

      else if(val.length < 3) {
        this.marketResults = []
        this.searchActive = false
        this.loadingResults = false
        this.activeMarket = null
      }
    },

    selectMarket(marketNr) {
      this.activeMarket = marketNr
    },

    async postThresholdCheck() {
      if(this.onlineState) {
        await this.endDepositCollectionAfterCheck()
      } else {
        await this.saveToStorageAfterCheck()
      }
    },

    async endDepositCollectionAfterCheck() {
      this.thresholdValueExceeded = false
      let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
      await this.sendDepositCollection(currentDeposit).then((response) => {
        if(response === false) {
          this.triggerSnackbar = true
          this.saveToStorage()
        }
        else {
          localStorage.removeItem('currentDeposit')
          this.setSignatureSVG(null)
          if(!this.comesFromTours) {
            router.push({name: 'depositActions'})
          } else {
            router.go(-1)
          }
        }
      }).catch(() => {

      })
    },

    async endDepositCollection() {
      let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
      let depositValues = JSON.parse(localStorage.getItem('depositValues'))
      let totalAmount = 0;
      if(depositValues && depositValues.length > 0 && depositValues[0].price && currentDeposit['deposit']) {
        let keys = Object.keys(currentDeposit['deposit'])
        keys.forEach(el => {
          let item = depositValues.find(val => val.itemNo == el)
          totalAmount += item.price * currentDeposit['deposit'][el]
        })
      }

      if(totalAmount >= 500) {
        this.thresholdValueExceeded = true
      } else {
        await this.sendDepositCollection(currentDeposit).then((response) => {
          if(response === false) {
            this.triggerSnackbar = true
            this.saveToStorage()
          }
          else {
            localStorage.removeItem('currentDeposit')
            this.setSignatureSVG(null)
            if(!this.comesFromTours) {
              router.push({name: 'depositActions'})
            } else {
              router.go(-1)
            }
          }
        }).catch(() => {

        })
      }
    },

    saveToStorageAfterCheck() {
      this.thresholdValueExceeded = false
        let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
        if(this.signature !== null) {
          currentDeposit['signature'] = this.signature
        }

        if(localStorage.getItem('savedDeposits') === null) {
          let savedDeposits = new Array()
          savedDeposits.push(currentDeposit)
          localStorage.setItem('savedDeposits', JSON.stringify(savedDeposits))
        }
        else {
          let savedDeposits = JSON.parse(localStorage.getItem('savedDeposits'))
          savedDeposits.push(currentDeposit)
          localStorage.setItem('savedDeposits', JSON.stringify(savedDeposits))
        }
        this.setSignatureSVG(null)
        localStorage.removeItem('currentDeposit')
        if(this.triggerSnackbar === true){
          setTimeout(() => {
            if(!this.comesFromTours) {
              router.push({name: 'depositActions'})
            } else {
              router.go(-1)
            }
          }, 2000)
        }
        else {
          if(!this.comesFromTours) {
            router.push({name: 'depositActions'})
          } else {
            router.go(-1)
          }
        }
    },
    saveToStorage() {
      let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
      if(this.signature !== null) {
        currentDeposit['signature'] = this.signature
      }
      // check offline
      let depositValues = JSON.parse(localStorage.getItem('depositValues'))
      let totalAmount = 0;
      if(depositValues && depositValues.length > 0 && depositValues[0].price && currentDeposit['deposit']) {
        let keys = Object.keys(currentDeposit['deposit'])
        keys.forEach(el => {
          let item = depositValues.find(val => val.itemNo == el)
          totalAmount += item.price * currentDeposit['deposit'][el]
        })
      }

      if(totalAmount >= 500) {
        this.thresholdValueExceeded = true
      } else {
        if(localStorage.getItem('savedDeposits') === null) {
          let savedDeposits = new Array()
          savedDeposits.push(currentDeposit)
          localStorage.setItem('savedDeposits', JSON.stringify(savedDeposits))
        }
        else {
          let savedDeposits = JSON.parse(localStorage.getItem('savedDeposits'))
          savedDeposits.push(currentDeposit)
          localStorage.setItem('savedDeposits', JSON.stringify(savedDeposits))
        }
        this.setSignatureSVG(null)
        localStorage.removeItem('currentDeposit')
        if(this.triggerSnackbar === true){
          setTimeout(() => {
            if(!this.comesFromTours) {
              router.push({name: 'depositActions'})
            } else {
              router.go(-1)
            }
          }, 2000)
        }
        else {
          if(!this.comesFromTours) {
            router.push({name: 'depositActions'})
          } else {
            router.go(-1)
          }
        }
      }
    }
  },

  computed: {
    ...mapState({
      signature: state => state.signatureSVG,
      depositCollector: state => state.depositCollector,
    }),

    nonSachetValues() {
      return this.depositValues.filter(el => {
        if(el.itemNo !== '79110') {
          return true
        } else {
          return false
        }
      })
    },

    sachetValues() {
      let sachet = this.depositValues.filter(el => {
        if(el.itemNo === '79110') {
          return true
        } else {
          return false
        }
      })
      let arr = []
      if(this.depositAmount !== null && this.depositAmount['79110'] !== undefined) {
        let sachets = this.depositAmount['79110'].length
        for(let i = 0; i<sachets;i++) {
          if(this.depositAmount['79110'][i] !== undefined) {
            arr.push(sachet[0])
          }
        }
      } else {
        arr.push(sachet[0])
      }
      return arr
    },

    markets()  {
      if (this.marketResults.length > 0 && this.marketSearchCbx.length > 3) {
        const searchVal = this.marketSearchCbx.toLowerCase().trim()
        return this.marketResults.filter(val =>
            (val.city ? val.city : '').toLowerCase().indexOf(searchVal) > -1 ||
            (val.address ? val.address : '').toLowerCase().indexOf(searchVal) > -1 ||
            (val.postal ? val.postal : '').toLowerCase().indexOf(searchVal) > -1 ||
            (val.customerNo ? val.customerNo : '').toString().indexOf(searchVal) > -1 ||
            (val.marketName ? val.marketName : '').toLowerCase().indexOf(searchVal) > -1)
      }
      else {
        return this.marketResults
      }
    },

    showSignature(state) {
      return state.signature
    },
  },

  created() {
    window.addEventListener("offline", () => {
      this.onlineState = false
    })
    window.addEventListener("online", () => {
      this.onlineState = true
    })

    //pre-Check if offline or online
    this.onlineState = window.navigator.onLine

    this.setHeaderVisibility(false)

    if(localStorage.getItem('depositValues') === null) {
      axios.get('/api/getDeposits')
          .then((result) => {
            this.depositValues = result.data
            localStorage.setItem('depositValues', JSON.stringify(result.data))
          })
    }
    else {
      this.depositValues = JSON.parse(localStorage.getItem('depositValues'))
    }

    this.initializeDeposit()
  },

  mounted() {
    if(this.externalSetMarket) {
      this.selectMarket(this.externalSetMarket)
      this.setMarket()
      this.depositStepper = 2
    }
  },

  watch: {
    marketSearchCbx() {
      this.searchMarkets(this.marketSearchCbx)
    },

    depositValues() {
      this.isLoading = false
    },
    depositStepper() {
      if(this.depositAmount !== null && this.depositAmount['79110'] !== undefined) {
        let sachets = this.depositAmount['79110'].filter(el => {
          if(el !== null) {
            return true
          } else {
            return false
          }
        })
        this.depositAmount['79110'] = sachets
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(vm.continuedDeposit) {
        vm.depositStepper = 2
      }
      else if(vm.continuedDeposit === false) {
        vm.depositStepper = 1
      }
      else if(Object.keys(JSON.parse(localStorage.getItem('currentDeposit'))).length > 0) {
        vm.depositStepper = 2
      }
    })
  }
}
</script>

<style>
  .depositListCard .continueBtn {
    bottom: -20px;
    margin-left: auto;
    left: -12px;
    background-color: var(--igros-red) !important;
  }

  .depositListCard {
    display: flex!important;
    flex-direction: column;
  }

  .depositListCard .searchCbx .v-input__slot {
    background-color: transparent!important;
    text-align: center;
  }

  .depositListInput.searchCbx .v-text-field__slot input{
    text-align: center;
  }

  .depositListContainer tr td:first-child {
    text-align: left;
    font-size: 14px;
    width: 65%;
  }

  .depositListContainer table:nth-child(2) tbody tr td {
    display: inline-flex;
    width: 300px;
  }
</style>
